{
  "version": 1,
  "asset_id": "f673aded-6d63-440b-a26f-d470f8fb7425",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/f673aded-6d63-440b-a26f-d470f8fb7425/stamped-gray-slate.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/f673aded-6d63-440b-a26f-d470f8fb7425/stamped-gray-slate.webp",
  "original_filename": "stamped-gray-slate.webp",
  "size": 93854,
  "content_type": "image/webp",
  "created_at": "2026-08-16T22:26:36Z"
}
